/**
 * Tap-to-place line tools (lines, symmetry lines, dot-grid tessellation e.g. HABS 2015 Q18a).
 * Tapping/clicking never removes a line: an existing dot, endpoint or line is just a point to
 * draw from. Removal is only via "Clear last line" / clear. Keep in sync with
 * nextLineTapState / appendInteractiveLine in the mobile interactiveDiagramMobile.ts.
 */
export const LINE_MIN_LENGTH = 0.025;

const close = (p, q) => Math.hypot(p[0] - q[0], p[1] - q[1]) < 1e-6;

/** Add a segment unless it is zero/too short or already drawn (either direction). */
export function appendDrawnLine(lines, a, b, minLength = LINE_MIN_LENGTH) {
  if (!a || !b || Math.hypot(b[0] - a[0], b[1] - a[1]) < minLength) {
    return { lines, changed: false, tooShort: true };
  }
  const dup = lines.some(([p, q]) => (close(p, a) && close(q, b)) || (close(p, b) && close(q, a)));
  if (dup) return { lines, changed: false, tooShort: false };
  return { lines: [...lines, [a, b]], changed: true, tooShort: false };
}

/**
 * - no pending: tap becomes the start
 * - same point again / too short: no-op, start stays armed
 * - otherwise: add the segment (unless duplicate) and clear the start
 */
export function nextLineTapState(lines, pending, tapped, minLength = LINE_MIN_LENGTH) {
  if (!pending) return { lines, pending: tapped, changed: false };
  const r = appendDrawnLine(lines, pending, tapped, minLength);
  if (r.tooShort) return { lines, pending, changed: false };
  return { lines: r.lines, pending: null, changed: r.changed };
}
